'use strict';

function fullPageScroll() {
    var footerMoveFlag = false;
    $('#fullpage').fullpage({
        css3: false,
        controlArrows: false,
        sectionSelector: '.section',
        keyboardScrolling: false,
        scrollingSpeed: 1000,
        fitToSectionDelay: 400,
        
        onLeave: function onLeave(origin, destination, direction) {

        },
        afterLoad: function afterLoad(origin, destination, direction) {
            $('.slide_title, .header, .desktop-menu').fadeIn(1000);
            $('.main_container .ctext span, .animate-delay').addClass('animated');
        },
        afterRender: function afterRender() {
            $.fn.fullpage.moveTo(1);
        }
    });

    $(document).on('click', '.footer__logo-up-btn', function(){
        $.fn.fullpage.moveTo(1);
    })
}

function openMobMenu(){
    $(document).on('click', '.header_menu_btn', function(){
        $('.mobile-menu').slideToggle(300).toggleClass('open');
        $('.slide_title').fadeToggle(100);
        $(this).toggleClass('active');
    });
}

function setActiveMenuElem(){
    var sectionAnchor = $('.slide').attr('data-anchor');
    $('[data-menu="' + sectionAnchor +'"]').addClass('active');
}

$(document).ready(function () { 
    openMobMenu();
    setActiveMenuElem();
    $('video').closest('.video-container').append('<div class="background"></div>');
    $('.main_container').closest('body').find('.header-logo').fadeOut(0);
    console.log($('.main_container').closest('body').find('.header-logo').get(0));
});

$(window).load(function () {
    fullPageScroll();
    $('.preloader').fadeOut(0);
    if($(window).width() <= 666){
        $('.footer').removeClass('fp-auto-height');
    }
    $('.footer').css('height', window.innerHeight);
});

$(window).resize(function () {
    if($(window).width() <= 666){
        $('.footer').removeClass('fp-auto-height');
    }
});
//# sourceMappingURL=develop_1.js.map
